export enum ActivityDefinitionType {
  Executable = 1,
  OrchestrationRouter = 2,
  PipelineService = 3,
  Event = 4,
}

export enum ActivityEventType {
  Started = 1,
  Completed = 2,
  InProgress = 3,
}

export enum JobOperationType {
  Stopped = 1,
  Resumed = 2,
}

export enum PipelinePhaseType {
  None = 0,
  Extract = 1,
  Transform = 2,
  Load = 3,
}

export enum PipelineStatus {
  None = 0,
  Processing = 1,
  Success = 2,
  Failed = 3,
  Pending = 4,
  FailedProcessing = 5,
  Cancelled = 6,
}

export enum ReplayRequestType {
  Isolated = 1,
  Flow = 2,
  IsolatedEvent = 3,
}

export enum RouteType {
  PipelineJob = 1,
  PipelineQueue = 2,
}

export enum TelemetryType {
  Debug = 0,
  Info = 1,
  Warning = 2,
  Error = 3,
}

export enum WorkflowType {
  'Event Based' = 0,
  Revit = 1,
  'Revit w/Fab' = 3,
  AutoCad = 2,
  None = 4,
  Playground = 5,
}

export class EnumObject {
  public value: number;
  public text: string;
  constructor(value: number, text: string) {
    this.value = value;
    this.text = text;
  }
}

export enum EntityStatus {
  Active = 0,
  Disabled = 1,
  'Send Disabled' = 3,
  'Receive Disabled' = 4,
  Unknown = 99,
}

export enum StorageAccountType {
  ModelData = 1,
  ModelSync = 2,
  ImportBundle = 3,
}

export const ActivityDefinitionIds = {
  Bim360Publish: 29,
  // Add other activity definition IDs as needed
} as const;